import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { getAbbreviatedUnit } from 'helpers/unitsAbbreviation';
import formatNumber from 'helpers/formatNumber';
import { en, Locale } from '../../locales';

const styles = StyleSheet.create({
  header: {
    display: 'flex',
    backgroundColor: '#DFE2E7',
    padding: '2px 4px'
  },
  headerText: {
    fontFamily: 'Noto Sans',
    fontSize: 12,
    fontWeight: 'normal',
    color: '#14151C'
  },
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  },
  item: {
    width: '50%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 4
  },
  itemLabel: {
    fontFamily: 'Noto Sans',
    fontSize: 11,
    fontWeight: 'normal',
    width: 118,
    marginRight: 10,
    color: '#14151C'
  },
  itemValue: {
    fontFamily: 'Noto Sans',
    fontSize: 9,
    fontWeight: 'normal',
    color: '#14151C'
  }
});

type TankInformationType = {
  tankSizeValue: number;
  tankSizeUnit: string;
  tankCount: number;
  ratePerAcreValue: number;
  ratePerAcreUnit: string;
  totalProductValue: number;
  totalProductUnit: string;
};

export type TankInformationProps = {
  tankInformation: TankInformationType;
  locale: Locale;
};

const TankInformation = ({
  tankInformation,
  locale = en
}: TankInformationProps) => {
  return (
    <View wrap={false}>
      <View style={styles.header}>
        <Text style={styles.headerText}>{locale.tank_information.title}</Text>
      </View>
      <View style={styles.container}>
        <View style={[styles.item, { borderBottom: '1px solid #DFE2E7' }]}>
          <Text style={styles.itemLabel}>
            {locale.tank_information.tank_size}
          </Text>
          <Text style={styles.itemValue}>
            {formatNumber(
              tankInformation.tankSizeValue,
              getAbbreviatedUnit(tankInformation.tankSizeUnit)
            )}
          </Text>
        </View>
        <View style={[styles.item, { borderBottom: '1px solid #DFE2E7' }]}>
          <Text style={styles.itemLabel}>
            {locale.tank_information.tank_count}
          </Text>
          <Text style={styles.itemValue}>
            {formatNumber(tankInformation.tankCount, 'tanks')}
          </Text>
        </View>
      </View>
      <View style={styles.container}>
        <View style={[styles.item]}>
          <Text style={styles.itemLabel}>
            {locale.tank_information.overall_rate_per_acre}
          </Text>
          <Text style={styles.itemValue}>
            {`${formatNumber(
              tankInformation.ratePerAcreValue,
              getAbbreviatedUnit(tankInformation.ratePerAcreUnit)
            )}/ac`}
          </Text>
        </View>
        <View style={styles.item}>
          <Text style={styles.itemLabel}>
            {locale.tank_information.overall_total_product}
          </Text>
          <Text style={styles.itemValue}>
            {formatNumber(
              tankInformation.totalProductValue,
              getAbbreviatedUnit(tankInformation.totalProductUnit)
            )}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default TankInformation;
